import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=4dc4ccd4&scoped=true"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"
import style0 from "./Confirmation.vue?vue&type=style&index=0&id=4dc4ccd4&prod&lang=css"
import style1 from "./Confirmation.vue?vue&type=style&index=1&id=4dc4ccd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc4ccd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VDialog,VDivider,VSpacer})
